var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7542 0.169622C24.3564 -0.0587206 23.8668 -0.0561748 23.4707 0.175171L9.39742 8.4091H1.62187C0.914581 8.4091 0.341309 8.98237 0.341309 9.68966V23.4342C0.341309 24.1415 0.914581 24.7148 1.62187 24.7148H4.69517C5.40246 24.7148 5.97573 24.1415 5.97573 23.4342C5.97573 22.7269 5.40246 22.1537 4.69517 22.1537H2.90243V10.9702H9.77472C10.071 10.9702 10.3565 10.8678 10.584 10.6821L22.8364 3.51356V4.90895C22.8364 5.61624 23.4096 6.18951 24.1169 6.18951C24.8242 6.18951 25.3975 5.61624 25.3975 4.90895V1.28072C25.3975 0.821817 25.152 0.397965 24.7542 0.169622Z",
    fill: "url(#paint0_linear_2993_7206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1171 14.0002C23.4098 14.0002 22.8365 14.5735 22.8365 15.2808V29.7177L12.6784 24.3505C12.053 24.0201 11.2779 24.2587 10.9479 24.8845C10.6175 25.5098 10.8566 26.2849 11.4819 26.6149L23.519 32.9746C23.7064 33.0741 23.9121 33.1232 24.117 33.1232C24.3462 33.1232 24.575 33.0613 24.7782 32.9392C25.1624 32.7074 25.3976 32.2916 25.3976 31.8426V15.2807C25.3977 14.5735 24.8244 14.0002 24.1171 14.0002Z",
    fill: "url(#paint1_linear_2993_7206)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0816 2.11933C32.601 1.6003 31.7917 1.56825 31.2722 2.0489L0.410899 30.6052C-0.108128 31.0854 -0.139723 31.8956 0.340464 32.4147C0.593155 32.6879 0.936323 32.8257 1.2808 32.8257C1.59198 32.8257 1.90401 32.7134 2.1503 32.4855L33.0112 3.92917C33.5307 3.44852 33.5618 2.63836 33.0816 2.11933Z",
    fill: "url(#paint2_linear_2993_7206)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73271 8.625C9.02542 8.625 8.45215 9.19827 8.45215 9.90556V18.656C8.45215 19.3633 9.02542 19.9366 9.73271 19.9366C10.4395 19.9366 11.0133 19.3633 11.0133 18.656V9.90556C11.0133 9.19827 10.44 8.625 9.73271 8.625Z",
    fill: "url(#paint3_linear_2993_7206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2993_7206",
    x1: 0.341309,
    y1: 24.7148,
    x2: 25.0538,
    y2: -0.33902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2993_7206",
    x1: 10.7993,
    y1: 33.1232,
    x2: 29.2458,
    y2: 19.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2993_7206",
    x1: 0,
    y1: 32.8257,
    x2: 31.0382,
    y2: -0.511412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2993_7206",
    x1: 8.45215,
    y1: 19.9366,
    x2: 13.3246,
    y2: 18.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/muteIcon.20132e195a837fa5e7e3639aea70b30e.svg";
export { ForwardRef as ReactComponent };